import { uniq } from "lodash"
import { useMemo } from "react"

import { classAtoms } from "#atoms"
import { ClassConstructor } from "#customTypes/composedTypes/classTypes"
import { DOC_TYPES } from "#customTypes/composedTypes/firebaseTypes"
import { StudentConstructor } from "#customTypes/composedTypes/studentTypes"
import { Uuid } from "#customTypes/globalTypes"
import ArtworkUploadModal from "#forms/AddStudent/ArtworkUploadModal"
import { useSomeDocs } from "#hooks/jotai/useSubscription"

/**
 * Hosts the artwork upload confirmation for files dropped on an attendance
 * row. Mounted only after a drop (mirrors ArtworkUploadModalHost in
 * StudentProfileTabs), so the classes subscription never runs for sessions
 * where nothing is dropped. The class list is the student's attendance
 * history plus the session's own class — a tryout student may not carry the
 * hosting class in attendance yet, and it is the drop's default pick.
 */
const AttendanceArtworkDropHost = ({
  student,
  files,
  sessionClassId,
  onClose,
}: {
  student: StudentConstructor
  files: File[]
  sessionClassId: Uuid
  onClose: () => void
}) => {
  const classIds = useMemo(
    () =>
      uniq([sessionClassId, ...Object.keys(student.attendance ?? {})]).sort(),
    [sessionClassId, student.attendance]
  )

  const classes = useSomeDocs<ClassConstructor>(
    classAtoms,
    DOC_TYPES.CLASSES,
    classIds
  )

  return (
    <ArtworkUploadModal
      open
      onClose={onClose}
      studentId={student.id}
      studentName={student.name}
      classes={classes ?? []}
      initialClassId={sessionClassId}
      initialFiles={files}
    />
  )
}

export default AttendanceArtworkDropHost
